import React from 'react';
import PostListItem from './PostListItem';

export default function PostList({ postData }) {
  return (
    <div className="h-full">
      {postData && postData.length > 0 ? (
        <div className="space-y-3 px-4 pt-4 pb-20">
          {postData.map((item, index) => (
            <PostListItem key={index} item={item} />
          ))}
        </div>
      ) : (
        <div className="p-3 text-center">
          <p className="text-slate-400">등록된 게시글이 없습니다.</p>
        </div>
      )}
    </div>
  );
}
